<div class="p-2">
  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Create Coupon</div>
  </div>

  <div class="row bg-light p-2">
    <!-- Steps -->
    <div class="col-12">
      <app-create-coupon-steps [module]="loginData?.user_details.provider_type" [step]="couponCreationStep" (stepSelection)="onStepSelection($event)"></app-create-coupon-steps>
    </div>

    <div class="col-12 mt-2">
      <div class="row">
        <!-- Action -->
        <div class="col-md-9 col-12">
          <div class="cell">
            <app-create-coupon-select-products [module]="loginData?.user_details.provider_type" (navigation)="onNavigationClick($event)" *ngIf="couponCreationStep == 1"></app-create-coupon-select-products>

            <app-create-coupon-set-details [module]="loginData?.user_details.provider_type" (navigation)="onNavigationClick($event)" *ngIf="couponCreationStep == 2"></app-create-coupon-set-details>

            <app-create-coupon-submit [module]="loginData?.user_details.provider_type" (navigation)="onNavigationClick($event)" *ngIf="couponCreationStep == 3"></app-create-coupon-submit>
          </div>
        </div>

        <!-- Preview -->
        <div class="col-md-3 col-12 bg-white p-0 m-0">
          <div class="row text-center">
            <div class="col-12">
              <app-create-coupon-preview [module]="loginData?.user_details.provider_type" [couponData]="couponData"></app-create-coupon-preview>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

